const VERSION = "4.0.5";
export {
  VERSION
};
